var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2721 2.66797H3.72663C3.14178 2.66797 2.66602 3.19131 2.66602 3.83466V6.83472C2.66602 7.47806 3.14178 8.0014 3.72663 8.0014H8.2721C8.85695 8.0014 9.33271 7.47806 9.33271 6.83472V3.83466C9.33271 3.19131 8.85695 2.66797 8.2721 2.66797Z",
    fill: "#1D3679"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2721 9.33203H3.72663C3.14178 9.33203 2.66602 9.78061 2.66602 10.3321V16.3322C2.66602 16.8836 3.14178 17.3322 3.72663 17.3322H8.2721C8.85695 17.3322 9.33271 16.8836 9.33271 16.3322V10.3321C9.33271 9.78061 8.85695 9.33203 8.2721 9.33203Z",
    fill: "#1D3679"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2721 12H11.7266C11.1418 12 10.666 12.5233 10.666 13.1667V16.1667C10.666 16.8101 11.1418 17.3334 11.7266 17.3334H16.2721C16.857 17.3334 17.3327 16.8101 17.3327 16.1667V13.1667C17.3327 12.5233 16.857 12 16.2721 12Z",
    fill: "#1D3679"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2721 2.66797H11.7266C11.1418 2.66797 10.666 3.11655 10.666 3.66799V9.6681C10.666 10.2195 11.1418 10.6681 11.7266 10.6681H16.2721C16.857 10.6681 17.3327 10.2195 17.3327 9.6681V3.66799C17.3327 3.11655 16.857 2.66797 16.2721 2.66797Z",
    fill: "#FD6202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d1724e3cb9ff88866cc95029efa24c80.svg";
export { ForwardRef as ReactComponent };